export const PAYMENT_AUDIT_ENTITY = "Payment";

export const buildPaymentAuditPayload = ({
  action,
  payment,
  companyId,
  reason,
  source = "admin_panel",
  changedFields = [],
  previousValues = {},
  newValues = {},
}) => {
  if (!payment?.id) return null;

  return {
    action,
    entityName: PAYMENT_AUDIT_ENTITY,
    entityId: payment.id,
    companyId:
      companyId ?? payment?.companyId ?? payment?.Company?.id ?? null,
    source,
    reason: reason || null,
    changedFields,
    previousValues,
    newValues,
  };
};
